import { isHelpPath } from "@/help/routes";
import { PAYROLL_SETTINGS_PATH } from "@/payroll/settings/routes";
import { isPathUnder } from "./nav-items";

export const isSidebarSwapPath = (pathname: string) =>
  isHelpPath(pathname) ||
  isPathUnder(pathname, "/business-settings") ||
  isPathUnder(pathname, PAYROLL_SETTINGS_PATH);

export const appPathToRemember = (pathname: string, remembered: string) =>
  isSidebarSwapPath(pathname) ? remembered : pathname;
